import styled from 'styled-components';

export const Container = styled.div``;

export const AreaButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.4rem;
  flex-wrap: nowrap;

  & .MuiButtonBase-root {
    margin-left: 0px;
    padding: 8px 25px !important;
    white-space: nowrap;
  }
`;

export const AreaReason = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-top: 0.4rem;

  .MuiInputBase-root {
    border: 1px solid ${({ theme }) => theme.grayDark};
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 2px;
  }
`;

export const AreaFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.4rem;
  background: ${({ theme }) => theme.grayLight};
`;
